import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { Card } from 'react-bootstrap';
import axios from ".././axios-interceptor";
import moment from "moment";
import { loanEventMessage,
  base_url,
  STATUS_NEW,
  STATUS_IN_PROGRESS,
  STATUS_PROCESSED,
  STATUS_REJECTED,
  STATUS_APPROVED,
  SERVICE_REQUEST_NEW_LOAN,
  SERVICE_REQUEST_EXTEND_TENURE,
  SERVICE_REQUEST_PRE_CLOSURE,
  SERVICE_REQUEST_PARTIAL_PRE_PAYMENT,
  STATUS_CLOSED,
  LOAN_REPAYMENT_BY_BUSINESS,
  LOAN_CURRENCY_TYPE_USD,
  formatMoney,
} from "../utilities";
import { ThreeDots } from "react-loader-spinner";
import { Table } from "react-bootstrap";
import { toast } from 'react-toastify';
import InvestorSideNavBar from './SideNavBarInvestor';
import InvestorNavBarMain from './InvestorNavBar';
import Cookies from 'js-cookie';

const InvestorProfile = () => {
  const navigate = useNavigate();
  const [uploadBtn, setUploadBtn] = useState(false)
  const [isLoading, setIsLoading] = useState(false)
  const [selectedFile, setSelectedFile] = useState('');
  const [imageUrl, setImageUrl] = useState('');
  const [investorProfileData, setInvestorProfileData] = useState([]);
  const [kycDocuments, setKYCDocuments] = useState([]);
  const [loanhistory, setLoanHistory] = useState([]);
  const [invListOfPayments, setInvListOfPayments] = useState([]);
  // Available balance comes from the backend (amount_transferred - disbursed - pledged_amount).
  const [balance, setBalance] = useState(null);

  const titles = ["Type", "Uploaded By", "Actions"];
  const headers = ["Ref No", "Paid Amount", "Paid Date"];
  const headings = [{title:"Date", sort:"paid_date"}, {title:"Amount", sort:"paid_amount"}, {title:"Via", sort:"received_via"}, {title:"Comment"}];


  
  useEffect(() => {

    axios
      .post(base_url + "investor-master/get_investor_profile", {
        "investor_id": Cookies.get("investor_id"),
      })
      .then((res) => {

        let data = res.data.data;
        setSelectedFile(data.investor_image_url)
        if (data === '') {
          setIsLoading(true)
        }
        else {
          if (data.investor_image_url== null || data.investor_image_url== "") {
            data.investor_image_url= "https://media.istockphoto.com/id/1256603011/photo/business-network-concept-customer-support-shaking-hands.jpg?s=612x612&w=0&k=20&c=uRYJ6c2EyNO92w0wQlCScEVwbdoyHaXzfIxw1q7zNLA="
          }
          setInvestorProfileData(data)
          setInvListOfPayments(data.list_of_payments)
          setKYCDocuments(data.list_of_kyc_documents);
          setLoanHistory(data.business_loans_history);
        }
      })

    axios
      .post(base_url + "investor-master/get_investor_dashboard", {
        "investor_id": Cookies.get("investor_id"),
      })
      .then((res) => {
        const d = res?.data?.data;
        if (res?.data?.status === 200 && d && !Array.isArray(d) && d.available_balance !== undefined) {
          setBalance({
            available_balance: d.available_balance,
            pledged_amount: d.pledged_amount,
            currency_type: d.currency_type,
          });
        }
      })
      .catch(() => {})

  }, [])

  const balanceCurrency = balance?.currency_type || investorProfileData?.currency_type || LOAN_CURRENCY_TYPE_USD;


  let loanhistorydata = loanhistory;
  let loan_history_array = [];
  loanhistorydata?.map(each_history_record => {
    // D8: records with their own description are shown as-is (generic events, waivers, closure).
    if (each_history_record.description) {
      loan_history_array.push({ message: loanEventMessage(each_history_record), created_date_time: each_history_record.created_date_time });
      return;
    }
    //NEW LOAN REQUEST LIST
    if (each_history_record.status == STATUS_NEW && each_history_record.service_type_code == SERVICE_REQUEST_NEW_LOAN) {
      let message = "Business requested loan";
      let created_date_time = each_history_record.created_date_time;
      let message_object = {
        message: message,
        created_date_time: created_date_time
      }
      loan_history_array.push(message_object)
    }
    if ((!each_history_record.is_investor_interested) && (!each_history_record.is_admin_sent_terms_to_business)) {
      if (each_history_record.status == STATUS_IN_PROGRESS && each_history_record.service_type_code == SERVICE_REQUEST_NEW_LOAN) {
        let message = "Admin filled the profit percentage and sent to investors";
        let created_date_time = each_history_record.created_date_time;
        let message_object = {
          message: message,
          created_date_time: created_date_time
        }
        loan_history_array.push(message_object)
      }
    }
    if (each_history_record.status == STATUS_REJECTED && each_history_record.service_type_code == SERVICE_REQUEST_NEW_LOAN) {
      let message = "Admin rejected the new loan request";
      let created_date_time = each_history_record.created_date_time;
      let message_object = {
        message: message,
        created_date_time: created_date_time
      }
      loan_history_array.push(message_object)
    }
    if (each_history_record.status == STATUS_IN_PROGRESS && each_history_record.is_investor_interested === 1 && each_history_record.service_type_code == SERVICE_REQUEST_NEW_LOAN) {
      let message = "Investor has shown interest on this loan";
      let created_date_time = each_history_record.created_date_time;
      let message_object = {
        message: message,
        created_date_time: created_date_time
      }
      loan_history_array.push(message_object)
    }
    if (each_history_record.status == STATUS_IN_PROGRESS && each_history_record.is_admin_sent_terms_to_business === 1 && each_history_record.service_type_code == SERVICE_REQUEST_NEW_LOAN) {
      let message = "Admin sent loan terms and awaiting for business response";
      let created_date_time = each_history_record.created_date_time;
      let message_object = {
        message: message,
        created_date_time: created_date_time
      }
      loan_history_array.push(message_object)
    }

    if (each_history_record.status == STATUS_APPROVED && each_history_record.service_type_code == SERVICE_REQUEST_NEW_LOAN) {
      let message = "Business agreed the new loan request terms";
      let created_date_time = each_history_record.created_date_time;
      let message_object = {
        message: message,
        created_date_time: created_date_time
      }
      loan_history_array.push(message_object)
    }

    if (each_history_record.status == STATUS_PROCESSED && each_history_record.service_type_code == SERVICE_REQUEST_NEW_LOAN) {
      let message = (
        <div className='style_loan_txt'>
          Admin paid the requested loan amount <span style={{ color: "black", marginTop: "2px" }} className="ps-1 pe-1 fw-bold">{each_history_record.paid_currency + "\u00A0" + Number(each_history_record.paid_amount).toLocaleString()}</span> to business on <span style={{ color: "black", marginTop: "2px" }} className="ps-1 pe-1 fw-bold">{moment(each_history_record.paid_date).format('DD MMM YYYY')}</span>
        </div>
      );
      let created_date_time = each_history_record.created_date_time;
      let message_object = {
        message: message,
        created_date_time: created_date_time
      }
      loan_history_array.push(message_object)
    }
    if (each_history_record.status == LOAN_REPAYMENT_BY_BUSINESS && each_history_record.service_type_code == SERVICE_REQUEST_NEW_LOAN) {
      let message =

        <div className=''>
          Business repaid for the month of <span style={{ color: "black" }} className=" fw-bold">{moment(each_history_record.tenure_date).format('MMMM')}</span>, loan tenure amount <span style={{ color: "black" }} className="fw-bold">{each_history_record.paid_currency + "\u00A0" + Number(each_history_record.paid_amount).toLocaleString()}</span> to admin on <span style={{ color: "black" }} className="fw-bold">{moment(each_history_record.paid_date).format('DD MMM YYYY')}</span>
        </div>
      let created_date_time = each_history_record.created_date_time;
      let message_object = {
        message: message,
        created_date_time: created_date_time
      }
      loan_history_array.push(message_object)
    }


    if (each_history_record.status == STATUS_NEW && each_history_record.service_type_code == SERVICE_REQUEST_EXTEND_TENURE) {
      let message = "Business requested to extend loan tenure";
      let created_date_time = each_history_record.created_date_time;
      let message_object = {
        message: message,
        created_date_time: created_date_time
      }
      loan_history_array.push(message_object)
    }
    if (each_history_record.status == STATUS_APPROVED && each_history_record.service_type_code == SERVICE_REQUEST_EXTEND_TENURE) {
      let message = "Admin approved extend tenure request";
      let created_date_time = each_history_record.created_date_time;
      let message_object = {
        message: message,
        created_date_time: created_date_time
      }
      loan_history_array.push(message_object)
    }


    if (each_history_record.status == STATUS_REJECTED && each_history_record.service_type_code == SERVICE_REQUEST_EXTEND_TENURE) {
      let message = "Admin rejected the extend tenure request";
      let created_date_time = each_history_record.created_date_time;
      let message_object = {
        message: message,
        created_date_time: created_date_time
      }
      loan_history_array.push(message_object)
    }


    if (each_history_record.status == STATUS_NEW && each_history_record.service_type_code == SERVICE_REQUEST_PRE_CLOSURE) {
      let message = "Business requested for pre closure of a loan";
      let created_date_time = each_history_record.created_date_time;
      let message_object = {
        message: message,
        created_date_time: created_date_time
      }
      loan_history_array.push(message_object)
    }
    if (each_history_record.status == STATUS_APPROVED && each_history_record.service_type_code == SERVICE_REQUEST_PRE_CLOSURE) {
      let message = "Admin approved pre closure request";
      let created_date_time = each_history_record.created_date_time;
      let message_object = {
        message: message,
        created_date_time: created_date_time
      }
      loan_history_array.push(message_object)
    }
    if (each_history_record.status == STATUS_REJECTED && each_history_record.service_type_code == SERVICE_REQUEST_PRE_CLOSURE) {
      let message = "Admin rejected pre closure request";
      let created_date_time = each_history_record.created_date_time;
      let message_object = {
        message: message,
        created_date_time: created_date_time
      }
      loan_history_array.push(message_object)
    }
    if (
      each_history_record.status == STATUS_NEW &&
      each_history_record.service_type_code == SERVICE_REQUEST_PARTIAL_PRE_PAYMENT
    ) {
      let message = "Business requested for partial pre-payment of a loan";
      let created_date_time = each_history_record.created_date_time;
      let message_object = {
        message: message,
        created_date_time: created_date_time,
      };
      loan_history_array.push(message_object);
    }
    if (
      each_history_record.status == STATUS_APPROVED &&
      each_history_record.service_type_code == SERVICE_REQUEST_PARTIAL_PRE_PAYMENT
    ) {
      let message = "Admin approved partial pre-payment request";
      let created_date_time = each_history_record.created_date_time;
      let message_object = {
        message: message,
        created_date_time: created_date_time,
      };
      loan_history_array.push(message_object);
    }
    if (
      each_history_record.status == STATUS_REJECTED &&
      each_history_record.service_type_code == SERVICE_REQUEST_PARTIAL_PRE_PAYMENT
    ) {
      let message = "Admin rejected partial pre-payment request";
      let created_date_time = each_history_record.created_date_time;
      let message_object = {
        message: message,
        created_date_time: created_date_time,
      };
      loan_history_array.push(message_object);
    }
    if (each_history_record.status == STATUS_CLOSED && each_history_record.service_type_code == SERVICE_REQUEST_NEW_LOAN) {
      let message = "Business repaid the loan successfully"
      let created_date_time = each_history_record.created_date_time;
      let message_object = {
        message: message,
        created_date_time: created_date_time
      }
      loan_history_array.push(message_object)
    }
  })

  const handleDownload = async (url, document_type) => {

    try {
      const response = await fetch(url);
      const blob = await response.blob();
      const objectUrl = URL.createObjectURL(blob);
      const a = document.createElement("a");
      a.href = objectUrl;
      a.download = investorProfileData.investor_name + "_" + document_type; // file name
      a.click();
      URL.revokeObjectURL(objectUrl);
    } catch (err) {
      console.log(err);
    }
  };
  useEffect(() => {
  if (!Cookies.get("User_Accesstoken_Investor")) {
    navigate('/');
  }
}, []);
  const [imgFlag, setImgFlag] = useState(false)

  const handleEditProfile = () => {
    setUploadBtn(true)

  }
  const [file, setUploadFile] = useState(""); //setUploadedUrl
  const [url, setUploadedUrl] = useState();

  const handleFileInputChange = (e) => {
    const fileName = e.target.files[0].name;
    const lastDotIndex = fileName.lastIndexOf('.');
    const fileExtension = fileName.substring(lastDotIndex + 1);
    if (fileExtension == "png" || fileExtension == "jpeg"|| fileExtension == "jpg" || fileExtension == "svg") {
      setImgFlag(true)
      setSelectedFile(URL.createObjectURL(e.target.files[0]));
      const url = URL.createObjectURL(e.target.files[0]);
      setImageUrl(url);
      setUploadFile(e.target.files[0].name);
      setUploadedUrl(e.target.files[0]);
    }
    else {
      toast.error("Please upload a profile in either SVG, PNG or JPEG format.", { toastId: 98 })
    }
  }
  const handleSaveChanges = () => {
    if(url !=null){
      setUploadBtn(false)
      const fd1 = new FormData();
      fd1.append('updated_by', Cookies.get("investor_user_name"))
      fd1.append('investor_id', Cookies.get("investor_id"));
      const fileName = file;
      const lastDotIndex = fileName.lastIndexOf('.');
      const fileExtension = fileName.substring(lastDotIndex + 1);
        fd1.append('file', url, fileExtension);
      axios.post(base_url + "investor-master/update_investor_profile_image", fd1, {
        headers: {
            'Content-Type': 'multipart/form-data'
        }
    }).then((res) => {
        toast.success("Image uploaded successfully", {
          toastId: 90,
        });
        setTimeout(() => {
          window.location.reload();
        });
      })
    }
    else{
      toast.error("Please upload a profile picture", { toastId: 98 })
    }

  }
  const handleCancelChanges =()=>{
    setUploadBtn(false)
  }

  let splitdata;
  let aboutdata = investorProfileData.about;
  if (aboutdata !== undefined) {
    splitdata = aboutdata.split(". ");
  }
  const [sortOrder, setSortOrder] = useState({ column: null, direction: null });

  const handleSort = (column) => {
    let direction = "asc";
    if (sortOrder.column === column && sortOrder.direction === "asc") {
      direction = "desc";
    }
    setSortOrder({ column, direction });

    const sortedData = [...invListOfPayments].sort((a, b) => {
      const columnA = a[column];
      const columnB = b[column];
      if (typeof columnA === "string" && typeof columnB === "string") {
        return direction === "asc"
          ? columnA.localeCompare(columnB)
          : columnB.localeCompare(columnA);
      } else if (typeof columnA === "number" && typeof columnB === "number") {
        return direction === "asc" ? columnA - columnB : columnB - columnA;
      } else {
        return 0;
      }
    });
    setInvListOfPayments(sortedData);
  };


  return (
    <div style={{ display: 'flex', height: '100vh' }}>
      <InvestorSideNavBar />
      <main style={{ width: "100%" }}>
        <InvestorNavBarMain />

        {isLoading ?
          <div className="historyLoader">
            <ThreeDots
              height="90"
              width="90"
              radius="9"
              color="#3d79f3"
              ariaLabel="three-dots-loading"
              wrapperStyle={{}}
              wrapperClassName=""
              visible={isLoading}
            />
          </div> :



          <div className='p-3 pe-5 ps-5 db_body'>
            <div className='titleplusedit'>
              <h1>Profile Page</h1>
              <div className='d-flex gap-3'>
                {!uploadBtn && <button className="blue_btn px-4" onClick={handleEditProfile}>Edit Profile</button>}
                {uploadBtn && <button className="blue_btn  px-4" onClick={handleCancelChanges}>Cancel</button>}
                {uploadBtn && <button className="gray_btn px-4" onClick={handleSaveChanges}>Save Changes</button>}
              </div>


            </div>
            <div className='profile_maindiv2'>



              <div className="">
              
                <Card className=" d-flex justify-content-between">

                  <div className="d-flex">
                    <div className=' ' >


                    <div className=' inv_image_uploadbtndiv'>
  {uploadBtn && (
    <label className="Cpointer">
      
        <input type="file" onChange={(e) => handleFileInputChange(e)} />
        <span className="blue_btn ms-4 "><img src={"./images/upload.svg"} alt="" />Upload New</span>
      
    </label>
  )}
  <img srcSet={imgFlag ? selectedFile : investorProfileData.investor_image_url} alt="" />
</div>


                    </div>
                    <div className='p-2 ps-3' >
                    <div className='busprofMaintitle'>
                      <h4 className='' >{investorProfileData.investor_name}</h4>
                      <div className='inv_prof_background'><p>{investorProfileData.investor_background==='' || investorProfileData.investor_background == undefined ? "-" :investorProfileData.investor_background} </p></div>
                    </div>
                      <div className="d-flex gap-3 mt-2">
                        {/* <div className="b_inv_prof_tabs ms-0 ms-md-1">
                          <span> Total committed</span>
                          <p className="p_style">$&nbsp;{isNaN(Number(investorProfileData.committed_principal))? 0 : Number(investorProfileData.committed_principal).toLocaleString()}</p>
                        </div> */}
                        <div className="n_inv_prof_tabs">
                          <span>Total Invested</span>
                          <p className="p_style">$&nbsp;{isNaN(Number(investorProfileData.disbursed))? 0 :Number(investorProfileData.disbursed).toLocaleString()}</p>
                        </div>
                        <div className="g_inv_prof_tabs">
                          <span>Total Available</span>
                          <p className="p_style">{balance ? formatMoney(balance.available_balance, balanceCurrency) : "-"}</p>
                        </div>
                        {Number(balance?.pledged_amount) > 0 && (
                          <div className="b_inv_prof_tabs">
                            <span>Reserved for pending investments</span>
                            <p className="p_style">{formatMoney(balance.pledged_amount, balanceCurrency)}</p>
                          </div>
                        )}
                      </div>

                    </div>
                  </div>
                </Card>
              </div>








              <div className=" profileBusDetailstab">
                <div className="">
                  <ul
                    className="nav nav-tabs d-flex"
                    id="myTab"
                    role="tablist"
                  >

                    <li className="nav-item-indiv-busns" role="presentation">
                      <button
                        className="nav-link-settingsProf p-1 active"
                        id="About-tab"
                        data-bs-toggle="tab"
                        data-bs-target="#About-tab-pane"
                        type="button"
                        role="tab"
                        aria-controls="About-tab-pane"
                        aria-selected="true"
                      >
                        <h3>About</h3>
                      </button>
                    </li>
                    <li className="nav-item-indiv-busns" role="presentation">
                      <button
                        className="nav-link-inv p-1"
                        id="Financials-tab"
                        data-bs-toggle="tab"
                        data-bs-target="#Financials-tab-pane"
                        type="button"
                        role="tab"
                        aria-controls="Financials-tab-pane"
                        aria-selected="false"
                      >
                        <h3>KYC Documents</h3>
                      </button>
                    </li>

                    <li className="nav-item-indiv-busns" role="presentation">
                      <button
                        className="nav-link-inv p-1"
                        id="loanhistory-tab"
                        data-bs-toggle="tab"
                        data-bs-target="#loanhistory-tab-pane"
                        type="button"
                        role="tab"
                        aria-controls="loanhistory-tab-pane"
                        aria-selected="false"
                      >
                        <h3>Investment Details</h3>
                      </button>
                    </li>
                    <li className="nav-item-indiv-busns" role="presentation">
                      <button
                        className="nav-link-inv p-1"
                        id="paymentDetails-tab"
                        data-bs-toggle="tab"
                        data-bs-target="#paymentDetails-tab-pane"
                        type="button"
                        role="tab"
                        aria-controls="paymentDetails-tab-pane"
                        aria-selected="false"
                      >
                        <h3>Repayment Details</h3>
                      </button>
                    </li>

                  </ul>
                </div>
                <div className="tab-content " id="myTabContent">

                  <div
                    className="tab-pane fade show active line_height_about_inv"
                    id="About-tab-pane"
                    role="tabpanel"
                    aria-labelledby="About-tab"
                    tabIndex="0"
                  >
                    <p className="paragraph">
                      <p className="paragraph">
                        {splitdata?.map((sentence, index) => (
                          <p key={index}>{"\n" + sentence.trim() + "."}</p>
                        ))}
                      </p>
                    </p>
                  </div>
                  <div
                    className="tab-pane fade Financials_tab"
                    id="Financials-tab-pane"
                    role="tabpanel"
                    aria-labelledby="Financials-tab"
                    tabIndex="0"
                  >
                    <div className="row allinv_doc_tab_styl">
                    <div className="inv_profile_kyc_table">
                <Table  striped  className=" my_loan_table " >
                  <thead>
                            <tr>
                              {kycDocuments === '' || kycDocuments === undefined ? <div className='text-center fw-bold fs-6 mt-2'>No Documents</div> : titles.map((title, id) => (
                                <th key={id}>{title}</th>
                              ))}
                            </tr>
                          </thead>
                          <tbody>
                            {kycDocuments?.map((doc, index) => {
                              return (
                                <tr key={index}>
                                  <td>
                                    {doc.document_type == undefined
                                      ? "-"
                                      : doc.document_type}
                                  </td>
                                  <td>
                                    {doc.created_by == undefined
                                      ? "-"
                                      : doc.created_by}
                                  </td>
                                  <td>
                                    <div className="d-flex justify-content-evenly">
                                      <div className="">
                                        <a
                                          style={{ display: "table-cell" }}
                                          href={doc.document_url}
                                          target="_blank"
                                        >
                                          <img src="./images/eye.svg" alt="" />
                                        </a>
                                      </div>
                                      <div
                                        className=" ps-3 Cpointer"
                                        onClick={() =>
                                          handleDownload(
                                            doc.document_url,
                                            doc.document_type
                                          )
                                        }
                                      >
                                        <img src="./images/down.svg" alt="" />
                                      </div>
                                    </div>
                                  </td>
                                </tr>
                              );
                            })}
                          </tbody>
                        </Table>
                      </div>
                    </div>
                  </div>


                  <div
                    className="tab-pane fade  "
                    id="loanhistory-tab-pane"
                    role="tabpanel"
                    aria-labelledby="loanhistory-tab"
                    tabIndex="0"
                  >
                    <div className="row allinv_doc_tab_styl">
                    <div className="inv_profile_kyc_table">
                <Table  striped  className=" my_loan_table " >
                  <thead>
                            <tr>
                              {investorProfileData.list_of_investments === '' || investorProfileData.list_of_investments === undefined ? <div className='text-center fw-bold fs-6 mt-2'>No Investments</div> : 
                              
                              
                              headers.map((title, id) => (
                                <th key={id}>{title}</th>
                              ))}
                            </tr>
                          </thead>
                          <tbody>
                            {investorProfileData.list_of_investments?.map((i, index) => {
                              return (
                                <tr key={index}>
                                  <td>
                                    {i.payment_to_business_reference_no == undefined
                                      ? "-"
                                      : i.payment_to_business_reference_no}
                                  </td>
                                  <td>
                                    {i.paid_amount == undefined
                                      ? "-"
                                      : "$"+Number(i.paid_amount).toLocaleString()}
                                  </td>
                                  <td>
                                    {i.paid_date == undefined
                                      ? "-"
                                      : moment(i.paid_date).format("DD MMM YYYY")}
                                  </td>
                                 
                                </tr>
                              );
                            })}
                          </tbody>
                        </Table>
                      </div>
                    </div>
                    
                  </div>

                  <div
                    className="tab-pane fade "
                    id="paymentDetails-tab-pane"
                    role="tabpanel"
                    aria-labelledby="paymentDetails-tab"
                    tabIndex="0"
                  >
                    <div className="row allinv_doc_tab_styl">
                    <div className="inv_profile_kyc_table">
                <Table  striped  className=" my_loan_table " >
                  <thead>
                            <tr>
                              {investorProfileData.list_of_payments === '' || investorProfileData.list_of_payments === undefined ? <div className='text-center fw-bold fs-6 mt-2'>No Payments</div> : 
                              
                              
                              headings.map((data) => (
                                <th
                                key={data.sort}
                                onClick={() => handleSort(data.sort)}
                              >
                                {data.title !== 'Comment' ? <div> {data.title}&#9662;</div> : <div>{data.title}</div>} 
                              </th>
                              ))}
                            </tr>
                          </thead>
                          <tbody>
                            {invListOfPayments?.map((i, index) => {
                              return (
                                <tr key={index}>
                                <td>
                                    {i.paid_date == undefined
                                      ? "-"
                                      : moment(i.paid_date).format("DD MMM YYYY")}
                                  </td>
                                  <td>
                                    {i.paid_amount == undefined
                                      ? "-"
                                      : "$"+Number(i.paid_amount).toLocaleString()}
                                  </td>
                                  <td>
                                    {i.received_via == undefined
                                      ? "-"
                                      : i.received_via}
                                  </td>
                                  <td style={{maxWidth:"400px"}}>
                                    {i.comments === undefined || i.comments === ''
                                      ? "-"
                                      : i.comments}
                                  </td>
                                 
                                </tr>
                              );
                            })}
                          </tbody>
                        </Table>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>}

      </main>
    </div>
  );
};

export default InvestorProfile;